import { mockReadsEnabled, realWritesEnabled } from '@/lib/feature-flags';

/**
 * Dev-only badge showing which data path is active for reads and writes.
 * Renders nothing outside `import.meta.env.DEV`. Mounted by the app shell.
 */
export function ModeBadge() {
  if (!import.meta.env.DEV) return null;

  const reads = mockReadsEnabled() ? 'mock' : 'live';
  const writes = realWritesEnabled() ? 'live' : 'mock';

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 8,
        right: 8,
        zIndex: 9999,
        padding: '4px 8px',
        borderRadius: 6,
        background: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        font: '11px ui-monospace, monospace',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
      data-testid="tahiti-mode-badge"
    >
      reads: {reads} · writes: {writes}
    </div>
  );
}
